export const prizesList = [
  {
    id: "aoc-c27g2u",
    name: "Игровой<br /> монитор AOC C27G2U",
    preview: require("@/assets/img/prizes/2021/aoc-c27g2u-preview.png"),
    href: "https://bit.ly/AOC_rr_2"
  },
  {
    id: "cooler-master-caliber-r1",
    name: "Игровое кресло<br /> Cooler Master<br /> Caliber R1",
    preview: require("@/assets/img/prizes/2021/cooler-master-caliber-r1-preview.png"),
    href: "https://clc.am/purple"
  },
  {
    id: "hyperx-quadcast",
    name: "Микрофон<br /> HyperX QuadCast",
    preview: require("@/assets/img/prizes/2021/hyperx-quadcast-preview.png"),
    href: "https://hyperx.gg/RBRR_QuadCast"
  },
  {
    id: "cooler-master-jacket",
    name: "Куртка<br /> Cooler Master",
    preview: require("@/assets/img/prizes/2021/cooler-master-jacket-preview.png"),
    href: "https://bit.ly/insta_cc"
  },
  {
    id: "hyperx-pulsefire-haste",
    name: "Игровая мышь<br /> HyperX Pulsefire Haste",
    preview: require("@/assets/img/prizes/2021/hyperx-pulsefire-haste-preview.png"),
    href: "https://hyperx.gg/RBRR_Raid"
  },
  {
    id: "hyperx-pulsefire-surge",
    name: "Игровая мышь<br /> HyperX Pulsefire Surge",
    preview: require("@/assets/img/prizes/2021/hyperx-pulsefire-surge-preview.png"),
    href: "https://hyperx.gg/RBRR_Raid"
  },
  {
    id: "hyperx-alloy-origins",
    name: "Механическая клавиатура<br /> HyperX Alloy Origins",
    preview: require("@/assets/img/prizes/2021/hyperx-alloy-origins-preview.png"),
    href: "https://hyperx.gg/RBRR_Origins"
  },
  {
    id: "hyperx-fury-ultra",
    name: "Коврик для мыши<br /> HyperX FURY Ultra",
    preview: require("@/assets/img/prizes/2021/hyperx-fury-ultra-preview.png"),
    href: "http://bit.ly/2MqAAh4"
  },
  {
    id: "cooler-master-mb511-argb",
    name: "Корпус<br /> Cooler Master<br /> MB511 ARGB",
    preview: require("@/assets/img/prizes/2021/cooler-master-mb511-argb-preview.png"),
    href: "https://clc.am/MB511ARGB"
  },
  {
    id: "cooler-master-tshirt",
    name: "Футболка<br /> Cooler Master",
    preview: require("@/assets/img/prizes/2021/cooler-master-tshirt-preview.png"),
    href: "https://bit.ly/insta_cc"
  }
];
